import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { postSignIn } from "../network/Network";
import { useDispatch, useSelector } from "react-redux";
import { LOGIN_SUCCESS, ROLE, USER_TOKEN } from "../redux/Slices/AuthSlice";

const SignIn = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const token = useSelector((state) => state?.Auth?.token);
	const myrole = useSelector((state) => state?.Auth?.role);
	// checkbox
	const [isChecked, setIsChecked] = useState(false);
	const [clickedButton, setClickedButton] = useState("");
	const [values, setValues] = React.useState({
		password: "",
		showPassword: false,
	});
	const [formErrors, setFormErrors] = useState([]);
	const [userData, setUserData] = useState({
		email: "",
		password: "",
	});
	const [loginData, setLoginData] = useState("");
	const [loading, setLoading] = useState(false);
	const [checked, setChecked] = useState(false);
	const [activeButton, setActiveButton] = useState(null);

	// Button Handler
	const handleClick = (buttonName) => {
		setClickedButton(buttonName);
	};
	//   ================

	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword });
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	const handleCheckboxChange = (e) => {
		const checked = e.target.checked;
		setIsChecked(checked);
	};

	// Remember me Funcitonality
	const handleRememeberMe = (event) => {
		setChecked(!checked);
	};

	useEffect(() => {
		const rememberMe = localStorage.getItem("rememberMe") === "true";
		const email = rememberMe ? localStorage.getItem("email") : "";
		const password = rememberMe ? localStorage.getItem("password") : "";
		setUserData({
			email: email,
			password: password,
		});
		setChecked(rememberMe);
	}, []);
	// =========================

	// Input Handler
	function handleChange(e) {
		const value = e.target.value;
		setUserData({ ...userData, [e.target.name]: value });
	}
	// =============

	// Sign in Handler
	const SiginHandler = (e) => {
		e.preventDefault();
		setLoading(true);

		let isValid = true;
		const errors = {};

		// Validate Email
		if (!userData?.email) {
			errors.email = ["Email is required"];
			isValid = false;
		} else if (!/\S+@\S+\.\S+/.test(userData.email)) {
			errors.email = ["Email is invalid"];
			isValid = false;
		}

		// Validate Password
		if (!userData?.password) {
			errors.password = ["Password is required"];
			isValid = false;
		} else if (userData.password.length < 8) {
			errors.password = ["Password must be at least 8 characters long"];
			isValid = false;
		}

		setFormErrors(errors);

		if (!isValid) {
			setLoading(false);
			return;
		}

		localStorage.setItem("rememberMe", checked);
		localStorage.setItem("email", checked ? userData?.email : "");
		localStorage.setItem("password", checked ? userData?.password : "");

		let data = {
			email: userData?.email,
			password: userData?.password,
		};

		postSignIn(data, clickedButton)
			.then((res) => {
				dispatch(LOGIN_SUCCESS(res?.data?.data));
				dispatch(USER_TOKEN(res?.data?.token));
				dispatch(ROLE(res?.data?.role));

				Swal.fire({
					position: "center",
					icon: "success",
					text: "Successfully Login",
					showConfirmButton: false,
					timer: 1500,
				});

				if (res?.data?.role === "physician") {
					navigate("/physician-personal-info");
				} else if (res?.data?.role === "patient") {
					// navigate(
					// 	res?.data?.attempt === 1 ? "/user-signup-detail" : "/personal-info",
					// );
					navigate("/personal-info");
				} else if (res?.data?.role === "pharmacy") {
					navigate("/pharmacy-perosnal-info");
				}

				setLoading(false);
			})
			.catch((err) => {
				setLoading(false);
				const errorData = err?.response?.data?.errors?.error;

				if (errorData) {
					if (Array.isArray(errorData)) {
						errorData.forEach((msg) =>
							Swal.fire({
								position: "center",
								icon: "error",
								text: msg,
								showConfirmButton: false,
								timer: 2200,
							}),
						);
					} else if (typeof errorData === "string") {
						Swal.fire({
							position: "center",
							icon: "error",
							text: errorData,
							showConfirmButton: false,
							timer: 2200,
						});
					} else if (typeof errorData === "object") {
						Object.values(errorData).forEach((msg) =>
							Swal.fire({
								position: "center",
								icon: "error",
								text: msg,
								showConfirmButton: false,
								timer: 2200,
							}),
						);
					}
				}
			});
	};

	// ============

	useEffect(() => {
		if (token) {
			navigate("/");
		}
	}, []);

	return (
		<>
			<div className="main-banner-heading1">
				<Header />
			</div>
			<section className="signin">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 mx-auto">
							<div className="main-bg-signin">
								<h2 className="main-heading level-2 text-center mt-3 mb-3 main-heading-font dark-color wow animate__animated animate__zoomIn">
									Sign In
								</h2>
								<div className="row mb-4 mt-4">
									<div className="col-md-4"></div>

									<div className="col-md-4"></div>

									<div className="col-md-4"></div>
								</div>
								<div className="row">
									<div className="col-lg-12 mb-2">
										<div className="form-group">
											<h5 className="primary-medium-font level-7 ">Email</h5>
											<input
												type="text"
												className="form-control"
												id="firstName"
												placeholder="Enter Email"
												name="email"
												value={userData?.email}
												onChange={handleChange}
											/>
											{<p className="forms-error">{formErrors?.email}</p>}
										</div>
									</div>
									<div className="col-lg-12">
										<div className="form-group">
											<h5 className="primary-medium-font level-7 ">Password</h5>
											<input
												type={values.showPassword ? "text" : "password"}
												className="form-control"
												id="password"
												placeholder=" Enter Password"
												name="password"
												value={userData?.password}
												onChange={handleChange}
											/>
											<button
												className="input-inline-btn shop-password wrapper-eye-signin"
												type="button"
											>
												<i
													onClick={handleClickShowPassword}
													onMouseDown={handleMouseDownPassword}
													className=" fa fa-eye"
												></i>
											</button>
										</div>
										{<p className="forms-error">{formErrors?.password}</p>}
									</div>
									<div className="row mt-3 ">
										<div className="col-lg-6 col-md-6 col-6">
											<div className="container-wrapper-access container-wrapper-access1">
												<label className="custom-checkbox">
													<input
														type="checkbox"
														id="Remember"
														className="form-check-input"
														value={checked}
														checked={checked}
														onChange={(e) => handleRememeberMe(e)}
													/>
													<span className="checkmark "></span>
													<h4 className="primary-medium-font level-7  mb-0 ">
														{" "}
														Remember me
													</h4>
												</label>
											</div>
										</div>
										<div className="col-lg-6 col-md-6 col-6  text-end">
											<Link
												className="header-link level-7 link-here primary-medium-font  extra-color-1"
												to="/forget-password"
											>
												<h4 className="primary-medium-font level-7 text-decoration-none  mb-0 ">
													{" "}
													Forgot Password
												</h4>
											</Link>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-lg-12">
										<Link
											className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
											onClick={(e) => SiginHandler(e)}
										>
											<span className="loading-btn loading bg-wrapper w-100">
												{loading ? (
													<i className="fa fa-spinner"></i>
												) : (
													"Sign In"
												)}
											</span>
										</Link>
									</div>
									<div className="col-lg-12">
										<h4 className=" level-7 text-center mt-3  primary-regular-font text-decoration-none extra-color-1">
											Don’t have an Account?{" "}
											<Link
												className="header-link level-7 link-here primary-medium-font text-decoration-none extra-color-1"
												to="/sign-up"
											>
												Sign Up
											</Link>
										</h4>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default SignIn;
